import React, { useState } from "react";
import copy from "../images/epic-copy.svg";
import edit from "../images/epic-edit.svg";
import copygray from "../images/epicgraycopy.svg";
import editgray from "../images/epic-pencil.svg";
import arrowBlue from "../images/optionBlue.svg";
import arrowUP from "../images/uparrow.svg";
import { ShowAlert } from "../../../common/alert";
import DictationComp from "./DictationComp";
import TemplateOptionsComp from "./TemplateOptionsComp";
import { Audio } from "./RecordingNoteComp";
import MedicalReport from "../../contentReaderMarkdown/markdownRenderer";
import generatingnote from "../images/generatingnote.gif";
import backicon from "../images/backicon.svg";
import epicsshare from "../images/epicsshare.svg";
import deleteicon from "../../epic/images/delete.svg";
import grayicon from "../images/Back (3).svg";
import star from "../images/staricon.svg";
import bluestar from "../images/bluestar.svg";
import { dateConversionGlobalEpic } from "../../../helper/CommonFuncs";
import { showSwalPopup } from "../actions/ShowSwalPopup";
import { WriteNoteToEhr } from "../../Vim-integration/components/WriteEncounterToVim";

const NoteDetails = ({
   SummaryData,
   tempId,
   noteId,
   signedUrl,
   dictationLoading,
   templateData,
   setEditComponents,
   updateNotesTemp,
   activeTab,
   setActiveTab,
   setNoteId,
   deleteNotes,
   setShowDeletePopup,
   isVimProvider,
}) => {
   const [openDropdown, setOpenDropdown] = useState(false);
   const note = SummaryData?.notes || null;
   const title = SummaryData?.title?.length === 0 || SummaryData.length === 0 ? "Clinical Note" : SummaryData?.title;
   const NoteId = SummaryData?.id || noteId;
   const dictation = signedUrl?.dictation || "";
   const tempTitle = SummaryData?.template?.title ? SummaryData?.template?.title : "Clinical Note";
   const time = SummaryData?.createdAt || null;
   const noteObject = SummaryData?.noteObject || null;
   const changeTab = (tab) => {
      setActiveTab(tab);
   };
   const handleDropDown = () => {
      setOpenDropdown(!openDropdown);
   };
   const handleEdit = () => {
      setEditComponents(true);
   };
   const copyContent = (text) => {
      navigator.clipboard
         .writeText(text)
         .then(() => {
            ShowAlert("Copied to clipboard.");
         })
         .catch((error) => {
            ShowAlert("Error copying messages", "error");
         });
   };
   function removeHashAndAsterisk(text) {
      if (typeof text !== "string") {
         return "Please provide a valid string.";
      }
      const modifiedText = text.replace(/[#*]/g, "");
      return modifiedText;
   }
   const modifiedText = note;

   const handleCopy = () => {
      if (activeTab === "tab1") {
         copyContent(removeHashAndAsterisk(modifiedText));
      } else {
         copyContent(removeHashAndAsterisk(dictation));
      }
   };

   const isNotePending = SummaryData?.status === "pending" || SummaryData?.length === 0 || SummaryData === null;
   return (
      <div className="d-relative epic-temp-diction-box ">
         <div className="notes-details-one">
            <div className="epic-note-title-container px-4">
               <div title={title} style={{ width: "55vw" }} className="note-title-text d-inline-block text-truncate ">
                  <img
                     onClick={() => {
                        setNoteId(null);
                     }}
                     src={backicon}
                     alt="back"
                     className="cursor-pointer mr-4 "
                  />
                  {title}
               </div>
               <div
                  className={` icone-container ${
                     activeTab === "tab1" ? "epic-action-box" : "epic-dictation-action-box"
                  }`}
               >
                  <div
                     onClick={() => {
                        if (!isNotePending) {
                           handleCopy();
                        }
                     }}
                     className={`${
                        !isNotePending && "cursor-pointer"
                     } d-flex justify-content-center justify-item-center text-center`}
                  >
                     <img src={isNotePending ? copygray : copy} alt="copy" />
                     <div className={`ml-3 ${isNotePending ? "epic-unactions-text " : "epic-actions-text "}`}>Copy</div>
                  </div>
                  <div className={` ${activeTab === "tab1" ? "analytics-line-v2" : "analytics-line-v2 ml-4"}`} />
                  {activeTab === "tab1" && (
                     <div
                        onClick={() => {
                           if (!isNotePending) {
                              handleEdit();
                           }
                        }}
                        className={`${
                           !isNotePending && "cursor-pointer"
                        } d-flex justify-content-center justify-item-center text-center`}
                     >
                        <>
                           <img src={isNotePending ? editgray : edit} alt="edit" />
                           <div className={`ml-3 ${isNotePending ? "epic-unactions-text " : "epic-actions-text"}`}>
                              Edit
                           </div>
                        </>
                     </div>
                  )}
                  {activeTab === "tab1" && <div className="analytics-line-v2" />}
                  {isVimProvider ? (
                     <WriteNoteToEhr noteObject={noteObject} icon={deleteicon} />
                  ) : (
                     <div
                        onClick={() => {
                           setShowDeletePopup(NoteId);
                        }}
                        className={`cursor-pointer d-flex justify-content-center justify-item-center text-center`}
                     >
                        <img src={deleteicon} alt="delet" />
                        <div className={`epic-actions-text ml-3`}>Delete</div>
                     </div>
                  )}
               </div>
            </div>
            <div className="epic-time-text ">{dateConversionGlobalEpic(time)}</div>
         </div>

         <div className="relative px-4">
            <div className="note-tabs">
               <div onClick={() => changeTab("tab1")} className=" ">
                  <button
                     style={{ maxWidth: "200px" }}
                     className={
                        activeTab === "tab1"
                           ? "active d-inline-block text-truncate font-weight-bold boader-margincursor-pointer"
                           : "d-inline-block text-truncate boader-margin"
                     }
                     title={tempTitle}
                  >
                     {tempTitle}
                  </button>
                  {activeTab === "tab1" ? (
                     <img
                        src={openDropdown ? arrowUP : arrowBlue}
                        alt="down"
                        style={{ paddingBottom: "8px" }}
                        className="cursor-pointer"
                        onClick={handleDropDown}
                     />
                  ) : (
                     <img src={grayicon} alt="grayicon" style={{ paddingBottom: "6px" }} className="" />
                  )}
                  <div
                     style={{ borderColor: "#043293", marginTop: "19px" }}
                     className={`${activeTab === "tab1" && " border-color-width"}`}
                  ></div>
               </div>
               <div className="epic-star-icon">
                  <img
                     src={activeTab === "tab1" ? star : bluestar}
                     alt="star"
                     className="mr-2"
                     style={{ paddingBottom: "5px" }}
                  />
                  <button
                     className={
                        activeTab === "tab2"
                           ? "active font-weight-bold epic-boader-margin cursor-pointer"
                           : "epic-boader-margin"
                     }
                     onClick={() => changeTab("tab2")}
                  >
                     Conversation
                  </button>
                  <div
                     style={{ borderColor: "#043293", marginTop: "15.5px" }}
                     className={`${activeTab === "tab2" && " epic-border-dictation font-weight-bold"}`}
                  ></div>
               </div>
            </div>
            <div className="border-bottom border"></div>
            <div style={{ marginLeft: "25px", marginRight: "25px" }} className="description-notes-cont-epic">
               {activeTab === "tab1" && (
                  <div className="scrole-width-new scrollbar-notes h-100  pt-4">
                     {isNotePending || SummaryData?.status === "draft" ? (
                        <div className="container-loader">
                           <div className="text-center ">
                              <img src={generatingnote} alt="generatingnote" className="image-generating-notes-new" />
                              <div className="generating-text">Generating Note</div>
                              <div className="notify-container">
                                 <div className="notify-text">Clinical Note generates in 30 seconds.</div>
                                 <div className="notify-text"> We'll notify you.</div>
                              </div>
                           </div>
                        </div>
                     ) : (
                        <MedicalReport content={note} />
                     )}
                  </div>
               )}
               {activeTab === "tab2" && (
                  <div className="scrole-width-new scrollbar-notes h-100 margin-dic">
                     <DictationComp dictation={dictation} dictationLoading={dictationLoading} />
                  </div>
               )}
            </div>
         </div>
         {openDropdown && (
            <TemplateOptionsComp
               templateData={templateData}
               setOpenDropdown={setOpenDropdown}
               tempId={tempId}
               NoteId={NoteId}
               updateNotesTemp={updateNotesTemp}
            />
         )}
         <div className={`epic-audio-absolute-pos epic-box-shadow mt-5 epic-audio-player-container flex-center`}>
            <Audio
               src={signedUrl?.url}
               // autoPlay={signedUrl?.url} box-shadow
               id="audio-subtitle"
               className=" w-95 mx-4"
            />
         </div>
      </div>
   );
};

export default NoteDetails;
